import React from "react";
import PropTypes from "prop-types";
import ControllerWidget from "./ControllerWidget";
import _ from "../../../../../shared/utils/ObjectUtils"
import LocalesUtils from "../../../../../shared/utils/LocalesUtils";
import GenericUtils from "../../../../../shared/utils/GenericUtils"
import { connect } from 'react-redux';
import DateTimeUtils from './../../../../../shared/utils/DateTimeUtils';
import { interfaceDataTypes } from './../../../../../interfaces/utils/InterfaceUtils';
import actions from "../../../../widgetsSagas/controller/actions";

class ControllerWidgetContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showTemporaryIcon : false,
            widgetOnEditMode: false,
            temporaryValue: null
        };
    }

    componentWillReceiveProps() {
        this.setState({
            showTemporaryIcon: false
        });
    }

    shouldComponentUpdate(nextProps, nextState) {
        const {
            temporaryValue,
            widgetOnEditMode
        } = this.state;

        const {
            value: previousValue,
            timestamp: previousTimestamp,
            interfaceDetails: previousInterfaceDetails
        } = this.props;

        const {
            value: nextValue,
            timestamp: nextTimestamp,
            interfaceDetails: nextInterfaceDetails
        } = nextProps;

        if (!_.isNil(temporaryValue)) {
            return true;
        }

        return !widgetOnEditMode ||
            previousValue !== nextValue ||
            previousTimestamp !== nextTimestamp ||
            nextState.temporaryValue !== temporaryValue ||
            nextState.widgetOnEditMode !== widgetOnEditMode ||
            !_.equals(previousInterfaceDetails, nextInterfaceDetails);
    }

    setWidgetOnEditMode = value => {
        this.setState({
            widgetOnEditMode : value,
            showTemporaryIcon: false,
            temporaryValue: undefined
        });
    };

    actOnInterface = value => {
        const {
            publishInterfaceValue,
            interfaceDetails: {
                id: interfaceId
            }
        } = this.props;

        publishInterfaceValue(interfaceId, value);

        this.setState({
            showTemporaryIcon: true,
            widgetOnEditMode: false,
            temporaryValue: value
        });
    };

    publishBooleanValue = value => {
        this.actOnInterface(value);
    };

    publishValue = () => {
        const { temporaryValue } = this.state;
        this.actOnInterface(temporaryValue);
    };

    onFieldChange = value => {
        const { 
            configs: {
                type,
                interfaceCategory
            }
        } = this.props;

        if(type !== interfaceDataTypes.BOOLEAN && interfaceCategory === "PERCENTAGE" && !_.isNil(value)) {
            if(value < 0) {
                value = 0
            } else if(value > 100) {
                value = 100;
            }
        }
        this.setState({
            temporaryValue: value
        });
    };

    render() {
        const {
            id,
            configs: {
                widgetDisplayName
            },
            value,
            timestamp: lastUpdateTimestamp,
            interfaceDetails: {
                name,
                dataType,  //Boolean, Numeric, String
                category: {
                    value: category  //SWITCH, TEMPERATURE, etc
                },
                unitType: {
                    properties: {
                        symbol, //º, %, etc
                        name: unitTypeName = {} // {true: 'ON', false: 'OFF'}
                    } = {}
                } = {}
            },
            widgetHasError,
            isEditMode,
            isDashboardFullScreen,
            onForceUpdateClick = () => {},
            onEditClick = () => {},
            onDuplicateClicked = () => {},
            onDeleteClicked = () => {}
        } = this.props;

        const {
            temporaryValue,
            showTemporaryIcon,
            widgetOnEditMode
        } = this.state;


        let valueDescription,
            valueToDisplay = !_.isNil(value) && dataType === interfaceDataTypes.BOOLEAN? GenericUtils.stringToBoolean(value) : value;

        if(!_.isNil(temporaryValue) && (showTemporaryIcon || widgetOnEditMode)) {
            valueToDisplay = temporaryValue;
        }

        if(dataType !== interfaceDataTypes.BOOLEAN && category === "PERCENTAGE" && !_.isNil(value) && !_.isEmpty(value)) {
            valueToDisplay = (parseInt(value)).toFixed(0);
        } else if(dataType === interfaceDataTypes.BOOLEAN && !_.isEmpty(unitTypeName)) {
            valueDescription = LocalesUtils.getLocaleString(unitTypeName[value])
        }

        return (
            <ControllerWidget
                widgetId={id}
                widgetDisplayName={widgetDisplayName}

                interfaceName={name}
                value={valueToDisplay}
                valueDescription={valueDescription}
                lastUpdateTimestamp={!_.isNil(lastUpdateTimestamp) ? DateTimeUtils.getDateTimeFromUnix(lastUpdateTimestamp) : '- - -'}
                interfaceUnitType={symbol}
                dataType={dataType}

                showTemporaryIcon={showTemporaryIcon}
                widgetOnEditMode={widgetOnEditMode}

                onFieldChange={this.onFieldChange}
                onControllerSubmitClicked={this.publishValue}
                onControllerButtonToggled={this.publishBooleanValue}
                onEditValueClicked={() => this.setWidgetOnEditMode(true)}
                onCancelClicked={()=> this.setWidgetOnEditMode(false)}

                //dashboard state
                isEditMode={isEditMode}
                isDashboardFullScreen={isDashboardFullScreen}

                //callbacks
                onForceUpdateClick={onForceUpdateClick}
                onEditClick={onEditClick}
                onDuplicateClicked={onDuplicateClicked}
                onDeleteClicked={onDeleteClicked}
                widgetHasError={widgetHasError}
            />
        );
    }
}

ControllerWidgetContainer.propTypes = {
    configs: PropTypes.object,
    value: PropTypes.any,
    timestamp: PropTypes.number,
    interfaceDetails: PropTypes.object,
    isEditMode: PropTypes.bool,
    isDashboardFullScreen: PropTypes.bool,
    onRefreshClicked: PropTypes.func,
    onForceUpdateClick: PropTypes.func,
    onEditClick: PropTypes.func,
    onDuplicateClicked: PropTypes.func
};

ControllerWidgetContainer.defaultProps = {
    interfaceDetails: {
        dataType: '',
        category: {
            value: ''
        },
        unitType: {
            value: '',
            properties: {
                symbol: '',
                name: {}
            }
        }
    }
};

const mapDispatchToProps = {
    publishInterfaceValue: actions.publishInterfaceValue,
};

export default connect(
    null,
    mapDispatchToProps
)(ControllerWidgetContainer);